import BaseModel from "./BaseModel";

export type LearnDashProgressionState =
  | "on_track"
  | "struggling"
  | "falling_behind";
export type StudentStatisticsResponse = {
  id: number;
  average_session_duration: number;
  canceled_by_student_sessions_count: number;
  canceled_sessions_count: number;
  completed_sessions_count: number;
  created_at: string;
  failed_notes_count: number[];
  learn_dash_progression_state: LearnDashProgressionState;
  passed_notes_count: number[];
  quran_progress: (null | number)[];
  schedule_requests_count: number;
  scheduled_sessions_count: number;
  session_tardiness: number[];
  student_absence_sessions_count: number;
  total_pages: number;
  total_read_pages: number;
  total_sessions_count: number;
  updated_at: string;
};

export default class StudentStatisticsModel extends BaseModel {
  average_session_duration: number;
  canceled_by_student_sessions_count: number;
  canceled_sessions_count: number;
  completed_sessions_count: number;
  failed_notes_count: number[];
  learn_dash_progression_state: LearnDashProgressionState;
  passed_notes_count: number[];
  quran_progress: (null | number)[];
  schedule_requests_count: number;
  scheduled_sessions_count: number;
  session_tardiness: number[];
  student_absence_sessions_count: number;
  total_pages: number;
  total_read_pages: number;
  total_sessions_count: number;

  constructor(data: StudentStatisticsResponse) {
    super(data);
    this.average_session_duration = data.average_session_duration;
    this.canceled_by_student_sessions_count =
      data.canceled_by_student_sessions_count;
    this.canceled_sessions_count = data.canceled_sessions_count;
    this.completed_sessions_count = data.completed_sessions_count;
    this.failed_notes_count = data.failed_notes_count;
    this.learn_dash_progression_state = data.learn_dash_progression_state;
    this.passed_notes_count = data.passed_notes_count;
    this.quran_progress = data.quran_progress;
    this.schedule_requests_count = data.schedule_requests_count;
    this.scheduled_sessions_count = data.scheduled_sessions_count;
    this.session_tardiness = data.session_tardiness;
    this.student_absence_sessions_count = data.student_absence_sessions_count;
    this.total_pages = data.total_pages;
    this.total_read_pages = data.total_read_pages;
    this.total_sessions_count = data.total_sessions_count;
  }

  get learnDashProgressionColorClass(): string {
    if (this.learn_dash_progression_state === "on_track") return "bg-green-500";
    if (this.learn_dash_progression_state === "struggling")
      return "bg-orange-500";
    return "bg-red-500";
  }

  get averageSessionDurationInMinutes(): number {
    return this.average_session_duration / 60;
  }
}
